import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LogoutInterceptor } from './logout.interceptor';

@NgModule({
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LogoutInterceptor,
            multi: true
        }
    ]
})
export class InterceptorModule {}



// WEBPACK FOOTER //
// ./src/shared/interceptors/interceptor.module.ts